var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "renderer", staticStyle: { "line-height": "1" } },
    [
      _c("MonitoringStatus", {
        attrs: {
          rmStatus: _vm.rmStatus,
          rmprocedures: !!_vm.rmprocedures ? _vm.rmprocedures : null,
          isCompact: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }